export default __webpack_public_path__ + "static/media/logoTheaccounter.8a9514d9.svg";